import React from 'react';
import {useLocation} from 'react-router-dom';

export default function ScrollToTop() {
  const {pathname, state} = useLocation();

  const preserveScroll = Boolean(
    (state as {preserveScroll?: boolean} | null)?.preserveScroll,
  );

  React.useEffect(() => {
    if (preserveScroll) return;

    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [pathname, preserveScroll]);

  return null;
}
